import { nameof } from '@work4all/data/lib/helper/nameof';

import { ServiceContract } from '@work4all/models/lib/Classes/ServiceContract.entity';
import { ServiceContractPosition } from '@work4all/models/lib/Classes/ServiceContractPosition.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import schema from './schemata/serviceContractPosition-table-schema.json';
import { EntityTableLayoutV8Props } from './table/EntityTableLayoutV8';

export function ServiceContractPositionTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<ServiceContractPosition, never>({
    ...props,
    schema: schema as never,
    innerEntityQuery: {
      parentEntity: Entities.serviceContract,
      fieldName: nameof<ServiceContract>('positionList'),
    },
    enableFooter: false,
    enableMultiRowSelection: false,
  });

  const overrides: Partial<EntityTableLayoutV8Props> = {
    layout: 'table',
    areas: null,
    hideSearch: true,
    cardConfig: null,
    displayFooter: false,
    actions: {
      groupingEnabled: null,
    },
  };

  return (
    <EntityTableV8
      {...props}
      {...dataTable}
      hideToolbar
      overrides={overrides}
    />
  );
}
